import { useMutation, useQueryClient } from "@tanstack/react-query";
import TchrURL from "../../TchrURL";
import { useStytchSession, useStytch } from "@stytch/react";
import { useInvalidateUserStats } from "../user/useUserStats";
import { checkResponseStatus } from "@/lib/utils/responseChecker";
import i18n from "i18next";

const useUnauthenticatedCheckoutComplete = ({
  sessionId,
}: {
  sessionId: string;
}) => {
  const { session } = useStytchSession();
  const stytch = useStytch();
  const queryClient = useQueryClient();
  const invalidateUserStats = useInvalidateUserStats();

  return useMutation({
    mutationKey: ["checkout", "complete", "unauthenticated"],
    mutationFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.append("sessionId", sessionId);
      const url = new TchrURL("/payment/checkoutcomplete");
      url.search = searchParams.toString();

      const headers: HeadersInit = {
        "Content-Type": "application/json",
      };

      // Add auth header only if user is authenticated
      if (session) {
        const tokens = stytch.session.getTokens();
        if (tokens?.session_jwt) {
          headers.Authorization = `Bearer ${tokens.session_jwt}`;
        }
      }

      const response = await fetch(url, {
        method: "POST",
        headers,
        body: "",
      });
      checkResponseStatus(
        response,
        i18n.getFixedT?.(null, ["errors"]) || (i18n.t.bind(i18n) as any),
        { context: "payment.checkoutComplete" }
      );

      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
      invalidateUserStats();
    },
  });
};

export default useUnauthenticatedCheckoutComplete;
